import * as ProcessLyncMedServerDataActions from '@actions/process-lync-med-server-data/process-lync-med-server-data.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { RealtimeGatewayService } from '@services/index';
import { RealTimeNotify } from '@models/index';



@Injectable()
export class ProcessLyncMedServerDataEffects {

  constructor(private actions$: Actions, private realtimeGatewayService: RealtimeGatewayService) { }

  getNotifyProcessLyncMedServerData$ = createEffect(() => this.actions$.pipe(
    ofType(ProcessLyncMedServerDataActions.GetNotifyProcessLyncMedServerData),
    switchMap((action) => this.realtimeGatewayService.observe(action.equipmentId, action.commandTypeId).pipe(
      catchError((err) => of(
        ProcessLyncMedServerDataActions.GetNotifyProcessLyncMedServerDataFailure({ error: err })
        )
      ),
      mergeMap((data: RealTimeNotify) => [
        ProcessLyncMedServerDataActions.GetNotifyProcessLyncMedServerDataSuccess({ data }),
        ProcessLyncMedServerDataActions.GetProcessLyncMedServerData({ ...data })
      ],
      ),
    ),
    )
  ));

  getProcessLyncMedServerData$ = createEffect(() => this.actions$.pipe(
    ofType(ProcessLyncMedServerDataActions.GetProcessLyncMedServerData),
    mergeMap((action) => this.realtimeGatewayService.getDocument(action.equipmentId, action.commandTypeId).pipe(
      map((data) => ProcessLyncMedServerDataActions.GetProcessLyncMedServerDataSuccess({ data:{ data, equipmentId: action.equipmentId} }),
      ),
      catchError((err) => of(ProcessLyncMedServerDataActions.GetProcessLyncMedServerDataFailure({ error: err })))
    ))
  ));

}
